import api from '@/apis/di/accountingObjectAPI';
import Crud from '@/stores/crudBase';
var crud = new Crud('accountingObject', api);
const state = {
  ...crud.state,
  _config: {
    table: 'di_accounting_object',
    field: {
      key: 'accounting_object_id',
      code: 'accounting_object_code',
      name: 'accounting_object_name',
      quickFollow: 'inactive',
    },
  },
};
const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,
};
const mutations = {
  ...crud.mutations,
};

export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
